import { DisplayFormat, FetchStatus, Property, PropertyType } from "../../../../base/types";
import { useEffect, useState } from "react";

import { IAsyncBoundProperties } from "../../../../base/hooks";
import { IParagraphProps } from "./IParagraphProps";
import { formatValue } from "../../../helpers";
import { usePropertyDraftText } from './../../../../base/hooks/bound-properties/usePropertyDraftText';

export const ParagraphProperties = [
    { id: Property.Text, name: 'Text', type: PropertyType.String },
    { id: Property.Format, name: 'Format', type: PropertyType.DisplayFormat },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
]

export const useParagraphProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IParagraphProps>()
    const draftText = usePropertyDraftText({ bindings, property: Property.Text })

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const title = bindings.getValue<string>(Property.Tooltip);
        const textValue = bindings.getValue<string>(Property.Text);
        const format = bindings.getValue<DisplayFormat>(Property.Format);
        const text = formatValue(textValue, format);

        setProperties({ text, title })
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties, draftText }
}
